import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ADMIN_FEATURE_KEY } from './keys';
import { adminReducer } from './reducers/admin.reducer';
import { AdminEffects } from './effects/admin.effects';

export function provideAdminStore(): EnvironmentProviders[] {
    return [provideState(ADMIN_FEATURE_KEY, adminReducer), provideEffects(AdminEffects)];
}
